export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_JAPANESE.eaefbb62.svg";